import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import NotificationSystem from "react-notification-system";
import { style } from "../../../variables/Variables";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import Select from "react-select";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  getb2b,
  addNewPackage,
  getInsuredUsers,
  searchSpeciality,
  gettagstearwise,
  getcouponstagwise,
  getAllGroupDataForProductCatalogue,
  getFlashCreditTypes,
  getCountry,
  GetAllDoctors,
} from "../../../Listfunction";
import InputColor from "react-input-color";
import axios from "axios";

class addProductCatalogue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      package_logo: "",
      package_LogoData: "",
      oldCompanyLogofile: "",
      package_name: "",
      productCode: "",
      package_nameError: null,
      package_duration: "",
      free_trial: "",
      package_durationError: null,
      package_price: "",
      discounted_price: "",
      package_priceError: null,
      feature_chkError: null,
      n_o_calls: "",
      n_o_callsError: null,
      raya_discount: "",
      raya_discountError: null,
      lab_discount: "",
      lab_discountError: null,
      express_order: "",
      express_orderError: null,
      medicin_discount: "",
      medicin_discountError: null,
      cardHidden: true,
      processing: true,
      feature_chk: [],
      background_color: "",
      user_type: "1",
      package_type: "1",
      duration_type: "1",
      free_trial_type: "1",
      is_featured: "0",
      insurance_test: false,
      insurance_data: [],
      doctorspecialityItems: [],
      specialityList: [],
      packageLogoError: null,
      // claimPeriodType: "",
      addresslist: [
        {
          srno: 1,
          address_line_1: "",
          address_line_2: "",
          // city: "0",
          // state: "",
          // country: "1",
          // postalcode: "",
          // country_error: "",
          // city_error: "",
          // addresstypeError: "",
          // customaddressError: "",
          // addresstype: "",
          // customaddress: "",
        },
      ],
      insurance_details: [],
      tagList: [],
      tagListOption: [],
      couponList: [],
      coupon_id: [],
      standardFree: "",
      standardDiscount: "",
      standardBasePrice: "",
      standardDescription: "",
      expressFree: "",
      expressDiscount: "",
      expressBasePrice: "",
      expressDescription: "",
      islandWideFree: "",
      islandWideDiscount: "",
      islandWideBasePrice: "",
      islandWideDescription: "",
      noOfFreeValue: "",
      deliveryWelcomeNote: "",
      noOfFreeValueError: null,
      groupData: [],
      selectedGroup: [],
      claimValue: "",
      // claimPeriod: "",
      isClaimMedicine: false,
      isClaimLab: false,
      isClaimRaya: false,
      isClaimTalkNow: false,
      isClaimTalkLater: false,
      isClaimTalkGlobal: false,
      isClaimEchanneling: false,
      isClaimFamily: false,
      isClaimMother: false,
      isClaimFather: false,
      isClaimSister: false,
      isClaimBrother: false,
      isClaimSpouse: false,
      isClaimChild: false,
      medicinePolicyDetails: "",
      labPolicyDetails: "",
      rayaPolicyDetails: "",
      talkNowPolicyDetails: "",
      talkLaterPolicyDetails: "",
      talkGlobalPolicyDetails: "",

      creditTypeList: [],
      creditType: "",
      getAllDoctors: [],
      //   addressline1: [],
      feature_chk_data: [
        {
          id: 6,
          chk_value: 6,
          label: "Medicine",
          checked: false,
          placeholder: "Enter Discount",
          name: "medicine_discount",
          input_value: "",
          errorMessage: "Medicine discount is required.",
          isFlashCreditMedicine: true,
        },
        {
          id: 3,
          chk_value: 3,
          label: "Lab",
          checked: false,
          placeholder: "Enter Discount",
          name: "lab_discount",
          input_value: "",
          errorMessage: "Lab Discount is required.",
          isFlashCreditLab: true,
        },
        {
          id: 2,
          chk_value: 2,
          label: "Raya",
          checked: false,
          placeholder: "Enter Discount",
          name: "raya_flat_discount",
          input_value: "",
          errorMessage: "Raya Discount is required.",
          isFlashCreditRaya: true,
        },
        {
          id: 1,
          chk_value: 1,
          label: "Talk now",
          checked: false,
          placeholder: "Talk now",
          name: "no_of_calls",
          input_value: "",
          errorMessage: "Talk now is required.",
          unlimited: false,
          isFlashCreditTalkNow: true,
        },
        {
          id: 10,
          chk_value: 10,
          label: "Talk global",
          checked: false,
          placeholder: "Talk global ",
          name: "no_of_talk_global_calls",
          input_value: "",
          errorMessage: "Talk Later Global is required.",
          talkGlobelUnlimited: false,
          isFlashCreditTalkGlobal: true,
        },
        {
          id: 11,
          chk_value: 11,
          label: "Talk later",
          checked: false,
          placeholder: "Talk later",
          name: "no_of_talk_later_calls",
          input_value: "",
          errorMessage: "Talk Later is required.",
          talkLaterUnlimited: false,
          isFlashCreditTalkLater: true,
        },
        {
          id: 8,
          chk_value: 8,
          label: "Talk later speciality",
          checked: false,
          placeholder: "Talk later",
          name: "no_of_calls_talk_later",
          input_value: [],
          talkLaterSpecialitylUnlimited: false,
          errorMessage: "Talk later is required.",
        },
        {
          id: 4,
          chk_value: 4,
          label: "MBE",
          checked: false,
          placeholder: "MBE Price",
          name: "mbe_price",
          input_value: "",
          errorMessage: "MBE Price is required.",
        },
        {
          id: 5,
          chk_value: 5,
          label: "Delivery",
          checked: false,
          placeholder: "N.O Deliveries",
          name: "delivery",
          input_value: [
            {
              type: "standard",
              free: null,
              discount: null,
              base_price: null,
            },
            {
              type: "express",
              free: null,
              discount: null,
              base_price: null,
            },
            {
              type: "islandWide",
              free: null,
              discount: null,
              base_price: null,
            },
          ],
          errorMessage: "N.O Delivery is required.",
          standard: false,
          express: false,
          islandWide: false,
        },
        {
          id: 7,
          chk_value: 7,
          label: "Insurance",
          checked: false,
          placeholder: "N.O Insurance",
          name: "no_of_insurance_order",
          input_value: [],
          addresslist: [],
          errorMessage: "N.O Insurance order is required.",
        },
        {
          id: 9,
          chk_value: 9,
          label: "Partner & Coupon Management",
          checked: false,
          placeholder: "Partner & Coupon Management",
          name: "partner_and_coupon_management",
          value: [],
          errorMessage: "Partner & Coupon Management is required.",
        },
        {
          id: 12,
          chk_value: 12,
          label: "MBE Groups",
          checked: false,
          placeholder: "Select Group",
          name: "group",
          value: [],
          errorMessage: "Group is required.",
        },
        {
          id: 13,
          chk_value: 13,
          label: "Claim Module",
          checked: false,
          name: "claim",
          value: [],
          errorMessage: "Claim is required.",
        },
        {
          id: 14,
          chk_value: 14,
          label: "Talk Later Doctor wise",
          checked: false,
          name: "talkLaterDoctorWise",
          input_value: [],
          errorMessage: "Talk later doctor is required.",
        },
      ],
      country_detail: [],
      country_code: "",
      countryError: null,
      talkLaterSpecialityType: "",
      opdFamilyPrice: null,
      opdIndividualPrice: null,
      claimBillingCycle: null,
      claimBillingCycleOptions: [
        {
          label: "Monthly",
          value: "monthly",
        },
        {
          label: "Weekly",
          value: "weekly",
        },
      ],
      claimType: null,
      claimTypeOptions: [
        {
          label: "Per Employee",
          value: "per_employee",
        },
        {
          label: "Per Claim",
          value: "per_claim",
        },
      ],
      isUnlimitedClaim: false,
      isSystemClaimAllowed: true,
      isBankAccountNeeded: true,
      poolValue: null,
      claimValueError: null,
      isHospitalization: false,
      pharma: "Pharma",
      lab: "Lab",
      consult: "Consult",
      hospital: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handlePackageLogoFileChange =
      this.handlePackageLogoFileChange.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
  }
  // alert('Bingo')

  userType = [
    { value: 1, label: "B2B" },
    { value: 2, label: "B2C" },
    { value: 3, label: "B2B2C" },
  ];

  basicType = [
    { value: 1, label: "Normal" },
    { value: 2, label: "Basic" },
  ];

  duration_type = [
    { value: 1, label: "Days" },
    { value: 2, label: "Week" },
    { value: 3, label: "Month" },
    { value: 4, label: "Year" },
  ];

  free_trial_type = [
    { value: 1, label: "Days" },
    { value: 2, label: "Week" },
    { value: 3, label: "Month" },
    { value: 4, label: "Year" },
  ];

  async componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
    getCountry(obj).then((cdata) => {
      const countrydata = cdata.data;
      this.setState({
        country_detail: countrydata,
      });
    });

    searchSpeciality(obj).then((response) => {
      const mdata = response.data;
      var activespeciality = [];
      for (let i = 0; i < mdata.length; i++) {
        if (mdata[i].is_active == 1) {
          activespeciality.push(mdata[i]);
        }
      }

      let pcItems = [];
      activespeciality.map((x, i) => {
        pcItems.push({ value: x.id, label: x.title });
      });

      this.setState({
        doctorspecialityItems: pcItems,
        specialityList: activespeciality,
      });
    });

    getInsuredUsers(obj).then((res) => {
      const data = res.data;
      var array1 = this.state.insurance_details;
      // var array2 = array1.concat(data);
      // this.setState({
      //     insurance_details: array2,
      // });

      let insuranceUsers = [];
      // this.state.insurance_details.map((x, i) => {
      //     insuranceUsers.push({ value: x.id, label: x.name });
      // });
      // data.data.map((x, i) => {
      //     insuranceUsers.push({ value: x.id, label: x.name });
      // });
      // this.setState({
      //   insurance_data: insuranceUsers,
      // });
      let riderItems = [];
      data.data.map((x, i) => {
        riderItems.push({ value: x.id, label: x.name });
      });
      this.setState({
        insuranceUsers: riderItems,
      });
    });

    getAllGroupDataForProductCatalogue(obj).then((response1) => {
      var data = response1;
      this.setState({
        groupData: data.data,
      });
    });

    getFlashCreditTypes(obj).then((cdata) => {
      const flashCreditTypes = cdata.data;
      const CreditTypeOptions = flashCreditTypes.map((item) => {
        return {
          value: item.id,
          label: item.title,
        };
      });
      this.setState({
        creditTypeList: CreditTypeOptions,
      });
    });

    GetAllDoctors(obj).then((response) => {
      const mdata = response.data.data;
      const getAllDoctors = mdata.map((data) => {
        return {
          value: data.id,
          label: data.name,
        };
      });
      this.setState({ getAllDoctors: getAllDoctors });
    });
  }
  // addanother() {
  //   this.serial = 1;
  //   this.setState({
  //     addressaccess: "1",
  //     adressradio: "",
  //     addressline2: "",
  //     addressline1: "",
  //   });
  // }
  onChange = (event, i) => {
    const target = event.target;
    const value = target.value;
    if (target.name == "no_of_insurance_order") {
      var list = [...this.state.feature_chk_data];
      list[i]["input_value"] = value;
      this.setState({ feature_chk: list });
    } else {
      const re = /^\d*\.?\d*$/;
      if (re.test(value) == true) {
        var list = [...this.state.feature_chk_data];
        list[i]["input_value"] = value;
        this.setState({ feature_chk: list });
      }
    }
  };

  // handleAllChecked_noi = (e, i) => {
  //   var checked = e.target.checked;
  //   var list = [...this.state.feature_chk_data];
  //   list[i]["checked"] = checked;

  //   this.setState({ insurance_test: true });

  //   if (checked == false) {
  //     list[i]["input_value"] = "";
  //     this.setState({ insurance_test: false });
  //   }

  //   this.setState({ feature_chk: list });
  // };

  onSpecialityChange = (value, i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[idx].specility = value;
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onDoctorSelectChange = (value, i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    if (value.value !== arr_val[idx].doctors.value) {
      let removedDoctor = arr_val[idx].doctors;
      this.state.getAllDoctors.push({
        value: removedDoctor.value,
        label: removedDoctor.label,
      });
    }
    arr_val[idx].doctors = value;
    list[i]["input_value"] = arr_val;
    let selectedDoctors = arr_val.map((itemY) => {
      return itemY.doctors.value;
    });
    let removeSelectedDoctors = this.state.getAllDoctors.filter(
      (itemX) => !selectedDoctors.includes(itemX.value)
    );
    this.setState({ feature_chk: list, getAllDoctors: removeSelectedDoctors });
  };

  onCallChange = (e, i, idx) => {
    const re = /^\d*$/;

    if (re.test(e.target.value) == true) {
      var list = [...this.state.feature_chk_data];
      var arr_val = list[i]["input_value"];
      arr_val[idx].no_of_calls = e.target.value;
      list[i]["input_value"] = arr_val;
      this.setState({ feature_chk: list });
    }
  };

  handleInputChangeAddresslist1 = (e, i, y) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[y].address_line_1 = e.target.value;
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };
  handleInputChangeAddresslist2 = (e, i, y) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[y].address_line_2 = e.target.value;
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onNOCallAdd = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.push({
      specility: "",
      no_of_calls: "",
      isUnlimited: false,
    });
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onAddNewSpecialityDoctor = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    // arr1.filter(item => !arr2.includes(item));
    let selectedDoctors = arr_val.map((itemY) => {
      return itemY.doctors.value;
    });
    let removeSelectedDoctors = this.state.getAllDoctors.filter(
      (itemX) => !selectedDoctors.includes(itemX.value)
    );
    arr_val.push({
      doctors: "",
      no_of_calls: "",
    });
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list, getAllDoctors: removeSelectedDoctors });
  };

  onNOCallAdd_test = (i) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.push({
      address_line_1: "",
      address_line_2: "",
    });
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onNOCallRemove = (i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val.splice(idx, 1);
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  onTalkLaterDoctorWiseRemove = (i, idx) => {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    let removedDoctor = arr_val[idx].doctors;
    if (arr_val[idx].doctors.value != "") {
      this.state.getAllDoctors.push({
        value: removedDoctor.value,
        label: removedDoctor.label,
      });
    }
    arr_val.splice(idx, 1);
    list[i]["input_value"] = arr_val;
    this.setState({ feature_chk: list });
  };

  handleAllChecked_noc = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = [];
      list[i]["unlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedMedicine = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      // list[i]["isFlashCreditMedicine"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedLab = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      // list[i]["isFlashCreditLab"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedRaya = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      // list[i]["isFlashCreditRaya"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedTalkLaterGlobal = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["talkGlobelUnlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedTalkLaterUnlimited = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
      list[i]["talkGlobelUnlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllChecked_noi = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = [];
      list[i]["unlimited"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleAllChecked_pcm = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["value"] = [];
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedGroups = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["value"] = [];
    }

    this.setState({ feature_chk: list });
  };

  handleAllCheckedFreeDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = [];
      list[i]["more"] = false;
      list[i]["standard"] = false;
      list[i]["express"] = false;
      list[i]["islandWide"] = false;
      this.setState({ deliveryWelcomeNote: "", noOfFreeDelivery: "" });
    }

    this.setState({ feature_chk: list, noOfFreeValue: "" });
  };

  handleAllChecked = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == false) {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  onChange_tier = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({
      tiers: value,
    });
    await gettagstearwise(value, obj).then((res) => {
      const data = res.data;
      const tagoptions = data.tags.map((x, i) => {
        return {
          value: x,
          label: x,
        };
      });

      var current = this.state.tagListOption;
      current[value] = tagoptions;
      this.setState({ tagListOption: current });
    });
  };

  onChange_tags = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const userToken = token.token;

    this.setState({ tags: value });

    const tiers = this.state.tiers;
    await getcouponstagwise(value, tiers, userToken).then((res) => {
      const data = res.data;
      const coupunoptions = data.coupons.map((x, i) => {
        return {
          id: x.id,
          title: x.title,
        };
      });

      this.setState({ couponList: coupunoptions });
    });
  };

  onChange_coupons = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    var token = JSON.parse(localStorage.getItem("user"));
    const userToken = token.token;
    const couponSelect = this.state.couponList.filter(
      (item) => item.id === parseInt(value)
    );
    const featureCheckData = this.state.feature_chk_data.map((item) => {
      if (item.id === 9) {
        return {
          ...item,
          value: [...item.value, couponSelect[0]],
        };
      }
      return item;
    });
    this.state.coupon_id.push(value);
    this.setState({
      feature_chk_data: featureCheckData,
      couponList: [],
      tagListOption: [],
      tiers: "",
    });
  };

  onChangeGroups = async (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const selectedGroup = this.state.groupData.filter(
      (item) => item.id === parseInt(value)
    );
    const featureCheckData = this.state.feature_chk_data.map((item) => {
      if (item.id === 12) {
        return {
          ...item,
          value: [...item.value, selectedGroup[0]],
        };
      }
      return item;
    });
    this.state.selectedGroup.push(value);
    this.setState({
      feature_chk_data: featureCheckData,
    });
    target.value = "";
  };

  onRemove_coupon(i, indexs) {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["value"];
    arr_val.splice(indexs, 1);
    list[i]["value"] = arr_val;
    this.setState({ feature_chk: list });

    this.state.coupon_id.splice(indexs, 1);
    var remove_cpn = this.state.coupon_id;
    this.setState({ coupon_id: remove_cpn });
  }

  onRemove_groups(i, indexs) {
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["value"];
    arr_val.splice(indexs, 1);
    list[i]["value"] = arr_val;
    this.setState({ feature_chk: list });

    this.state.selectedGroup.splice(indexs, 1);
    var remove_group = this.state.selectedGroup;
    this.setState({ selectedGroup: remove_group });
  }

  onSubmit = async () => {
    if (this.state.package_logo.length != 0) {
      this.setState({ processing: true });
      const fdata = new FormData();
      fdata.append("company_logo", this.state.package_logo);

      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;
      let url = process.env.REACT_APP_NOT_SECRET_CODE + "/b2b/comapany/logo";
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          this.setState({
            package_LogoData: res.data.data.company_logo_url,
          });
        });
    } else {
      this.setState({ package_LogoData: this.state.oldCompanyLogofile });
    }

    let error = false;
    if (this.state.package_name.length == 0) {
      error = true;
      this.setState({
        package_nameError: (
          <small className="text-danger">Package Name is required.</small>
        ),
      });
    } else {
      this.setState({ package_nameError: null });
    }

    if (this.state.package_duration.length == 0) {
      error = true;
      this.setState({
        package_durationError: (
          <small className="text-danger">Duration is required.</small>
        ),
      });
    } else {
      this.setState({ package_durationError: null });
    }

    if (this.state.package_price.length == 0) {
      error = true;
      this.setState({
        package_priceError: (
          <small className="text-danger">Price is required.</small>
        ),
      });
    } else {
      this.setState({ package_priceError: null });
    }
    if (!this.state.country_code || this.state.country_code === "0") {
      error = true;
      this.setState({
        countryError: (
          <small className="text-danger">Country is required.</small>
        ),
      });
    } else {
      this.setState({ countryError: null });
    }
    if (!this.state.package_logo && !this.state.package_LogoData) {
      error = true;
      this.setState({
        packageLogoError: (
          <small className="text-danger">Package logo is required.</small>
        ),
      });
    } else {
      this.setState({ packageLogoError: null });
    }

    if (this.state.feature_chk.length == 0) {
      error = true;
      this.setState({
        feature_chkError: (
          <small className="text-danger">Feature is required.</small>
        ),
      });
    } else {
      this.setState({ feature_chkError: null });
    }

    const getClaimFeatureData = this.state.feature_chk_data.find(
      (data) => data.chk_value == "13"
    );
    if (getClaimFeatureData && getClaimFeatureData.checked) {
      if (
        (this.state.claimValue == "" || this.state.claimValue == null) &&
        this.state.isUnlimitedClaim == false
      ) {
        error = true;
        this.setState({
          claimValueError: (
            <small className="text-danger">
              Claim allocation or unlimited claim is required.
            </small>
          ),
        });
      } else {
        this.setState({ claimValueError: null });
      }
    }
    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      let insuranceData = [];
      const insurances = this.state.feature_chk_data.find(
        (data) => data.chk_value == "7"
      );
      insurances.input_value.map((x) => {
        insuranceData.push({
          insurance_key: x.address_line_1,
          insurance_value: x.address_line_2,
        });
      });
      // this.state.feature_chk_data["7"]["input_value"].map((x, i) => {
      // });

      const featureArr = this.state.feature_chk;
      const featureData = [];

      featureArr.map((s, i) => {
        if (s.name == "no_of_calls_talk_later") {
          var pcvalue = [];

          for (let xi = 0; xi < s.input_value.length; xi++) {
            var speid = s.input_value[xi].specility
              ? s.input_value[xi].specility.value
              : "";
            pcvalue.push({
              speciality_id: speid,
              no_of_calls: s.input_value[xi].no_of_calls,
            });
          }

          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: pcvalue,
          });
        } else if (s.name == "partner_and_coupon_management") {
          const cpn_id = this.state.coupon_id;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: cpn_id,
          });
        } else if (s.name == "delivery") {
          const standardFreeValue = this.state.standardFree;
          const standardDiscountValue = this.state.standardDiscount;
          const standardBasepriceValue = this.state.standardBasePrice;
          const expressFreeValue = this.state.expressFree;
          const expressDiscountValue = this.state.expressDiscount;
          const expressBasepriceValue = this.state.expressBasePrice;
          const islandWideFreeValue = this.state.islandWideFree;
          const islandWideDiscountValue = this.state.islandWideDiscount;
          const islandWideBasepriceValue = this.state.islandWideBasePrice;
          const noOfFreeDelivery = this.state.noOfFreeValue;
          // const deliveryWelcomeNote = this.state.deliveryWelcomeNote;
          // const standardDescription = this.state.standardDescription;
          // const expressDescription = this.state.expressDescription;
          // const islandWideDescription = this.state.islandWideDescription;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            // welcome_note: deliveryWelcomeNote,
            value: [
              {
                free: standardFreeValue == "" ? 0 : standardFreeValue,
                discount:
                  standardDiscountValue == "" ? 0 : standardDiscountValue,
                base_price:
                  standardBasepriceValue == "" ? 0 : standardBasepriceValue,
                // description: standardDescription,
                type: "standard",
              },
              {
                free: expressFreeValue == "" ? 0 : expressFreeValue,
                discount: expressDiscountValue == "" ? 0 : expressDiscountValue,
                base_price:
                  expressBasepriceValue == "" ? 0 : expressBasepriceValue,
                // description: expressDescription,
                type: "express",
              },
              {
                free: islandWideFreeValue == "" ? 0 : islandWideFreeValue,
                discount:
                  islandWideDiscountValue == "" ? 0 : islandWideDiscountValue,
                base_price:
                  islandWideBasepriceValue == "" ? 0 : islandWideBasepriceValue,
                // description: islandWideDescription,
                type: "island_wide",
              },
              {
                type: "sum",
                t_count: noOfFreeDelivery == "" ? 0 : noOfFreeDelivery,
              },
            ],
          });
        } else if (s.name == "group") {
          const groupId = this.state.selectedGroup;
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: groupId,
          });
        } else if (s.name == "medicine_discount") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditMedicine,
          });
        } else if (s.name == "lab_discount") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditLab,
          });
        } else if (s.name == "raya_flat_discount") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditRaya,
          });
        } else if (s.name == "no_of_calls") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditTalkNow,
          });
        } else if (s.name == "no_of_talk_global_calls") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditTalkGlobal,
          });
        } else if (s.name == "no_of_talk_later_calls") {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
            is_flash_credit_usable: s.isFlashCreditTalkLater,
          });
        } else if (s.name == "claim") {
          if (s.checked === true) {
            const claimValue = this.state.claimValue;
            // const claimPeriod = this.state.claimPeriod;
            const isClaimMedicine = this.state.isClaimMedicine;
            const isClaimLab = this.state.isClaimLab;
            const isClaimRaya = this.state.isClaimRaya;
            const isClaimTalkNow = this.state.isClaimTalkNow;
            const isClaimTalkLater = this.state.isClaimTalkLater;
            const isClaimTalkGlobal = this.state.isClaimTalkGlobal;
            const isClaimEchanneling = this.state.isClaimEchanneling;
            const isHospitalization = this.state.isHospitalization;
            const isClaimFamily = this.state.isClaimFamily;
            const isClaimMother = this.state.isClaimMother;
            const isClaimFather = this.state.isClaimFather;
            const isClaimBrother = this.state.isClaimBrother;
            const isClaimSister = this.state.isClaimSister;
            const isClaimSpouse = this.state.isClaimSpouse;
            const isClaimChild = this.state.isClaimChild;
            const claimType = this.state.claimType;
            // const claimPeriodType = this.state.claimPeriodType.value;
            // const credirType = this.state.creditType;
            const credirType = 4;
            const opdIndividualPrice = !!this.state.opdIndividualPrice
              ? this.state.opdIndividualPrice
              : "";
            const opdFamilyPrice = !!this.state.opdFamilyPrice
              ? this.state.opdFamilyPrice
              : "";
            const claimBillingCycle = !!this.state.claimBillingCycle
              ? this.state.claimBillingCycle
              : "";
            const isUnlimitedClaimAllocation = this.state.isUnlimitedClaim;
            const isSystemClaimAllowed = this.state.isSystemClaimAllowed;
            const isBankAccountNeeded = this.state.isBankAccountNeeded;
            const poolValue = this.state.poolValue;

            const manualClaimFeature = [
              this.state.pharma !== "" ? this.state.pharma : null,
              this.state.lab !== "" ? this.state.lab : null,
              this.state.consult !== "" ? this.state.consult : null,
              this.state.hospital !== "" ? this.state.hospital : null,
            ].filter((item) => item !== null);
            featureData.push({
              category_id: s.chk_value,
              title: s.name,
              value: [
                {
                  value: claimValue,
                  // period: claimPeriod,
                  medicine: isClaimMedicine,
                  lab: isClaimLab,
                  raya: isClaimRaya,
                  talkNow: isClaimTalkNow,
                  talkLater: isClaimTalkLater,
                  talkGlobal: isClaimTalkGlobal,
                  eChanneling: isClaimEchanneling,
                  hospitalization: isHospitalization,
                  talkFamily: isClaimFamily,
                  talkFamilyMother: isClaimFamily && isClaimMother,
                  talkFamilyFather: isClaimFamily && isClaimFather,
                  talkFamilyBrother: isClaimFamily && isClaimBrother,
                  talkFamilySister: isClaimFamily && isClaimSister,
                  talkFamilySpouse: isClaimFamily && isClaimSpouse,
                  talkFamilyChild: isClaimFamily && isClaimChild,
                  // periodType: claimPeriodType,
                  creditType: credirType,
                  opdIndividual: opdIndividualPrice,
                  opdFamilyPrice: opdFamilyPrice,
                  billingCycle: claimBillingCycle,
                  isUnlimitedAllocation: isUnlimitedClaimAllocation,
                  isSystemClaimAllowed: isSystemClaimAllowed,
                  isBankAccountNeeded: isBankAccountNeeded,
                  poolValue: poolValue,
                  manualClaims: manualClaimFeature,
                  claimType: claimType,
                },
              ],
              // policy: policyDetails,
            });
          } else {
            featureData.push({
              category_id: s.chk_value,
              title: s.name,
              value: [],
            });
          }
        } else if (s.name == "talkLaterDoctorWise") {
          const selectedDoctorId = s.input_value.map((item) => {
            return {
              doctorId: item.doctors.value,
              noOfCalls: item.no_of_calls,
            };
          });
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: selectedDoctorId,
          });
        } else {
          featureData.push({
            category_id: s.chk_value,
            title: s.name,
            value: s.input_value,
          });
        }
      });
      var user_type_p = parseInt(this.state.user_type);
      var package_type_p = parseInt(this.state.package_type);
      var insurance =
        this.state.insurance_id != undefined
          ? this.state.insurance_id.value
          : null;
      let claimValue = [];
      claimValue = [...claimValue];
      if (
        this.state.medicinePolicyDetails &&
        this.state.medicinePolicyDetails !== ""
      ) {
        claimValue.push({
          title: this.state.medicinePolicyDetails.title,
          value: !!this.state.medicinePolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.medicinePolicyDetails.value.getCurrentContent()
                )
              )
            : "",
        });
      }
      if (this.state.labPolicyDetails && this.state.labPolicyDetails !== "") {
        claimValue.push({
          title: this.state.labPolicyDetails.title,
          value: !!this.state.labPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.labPolicyDetails.value.getCurrentContent()
                )
              )
            : "",
        });
      }
      if (this.state.rayaPolicyDetails && this.state.rayaPolicyDetails !== "") {
        claimValue.push({
          title: this.state.rayaPolicyDetails.title,
          value: !!this.state.rayaPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.rayaPolicyDetails.value.getCurrentContent()
                )
              )
            : "",
        });
      }
      if (
        this.state.talkNowPolicyDetails &&
        this.state.talkNowPolicyDetails !== ""
      ) {
        claimValue.push({
          title: this.state.talkNowPolicyDetails.title,
          value: !!this.state.talkNowPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.talkNowPolicyDetails.value.getCurrentContent()
                )
              )
            : "",
        });
      }
      if (
        this.state.talkLaterPolicyDetails &&
        this.state.talkLaterPolicyDetails !== ""
      ) {
        claimValue.push({
          title: this.state.talkLaterPolicyDetails.title,
          value: !!this.state.talkLaterPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.talkLaterPolicyDetails.value.getCurrentContent()
                )
              )
            : "",
        });
      }
      if (
        this.state.talkGlobalPolicyDetails &&
        this.state.talkGlobalPolicyDetails !== ""
      ) {
        claimValue.push({
          title: this.state.talkGlobalPolicyDetails.title,
          value: !!this.state.talkGlobalPolicyDetails.value
            ? draftToHtml(
                convertToRaw(
                  this.state.talkGlobalPolicyDetails.value.getCurrentContent()
                )
              )
            : "",
        });
      }

      // const claimNew = [{
      //   title: "medicine",
      //   value: !!this.state.medicinePolicyDetails ? draftToHtml(convertToRaw(this.state.medicinePolicyDetails.value.getCurrentContent())) : ""
      //   ,
      // }]
      addNewPackage(
        this.state.package_name,
        this.state.package_duration,
        this.state.duration_type,
        this.state.package_description,
        this.state.package_price,
        this.state.background_color,
        featureData,
        user_type_p,
        package_type_p,
        insurance,
        insuranceData,
        this.state.is_featured,
        this.state.free_trial_type,
        this.state.free_trial,
        this.state.discounted_price,
        this.state.productCode,
        this.state.country_code,
        this.state.package_LogoData,
        claimValue,
        obj
      )
        .then((res) => {
          if (res.data.success === true) {
            this.handleSuccess("bl");
          }
        })
        .catch((error) => {
          console.log(error, "== error");
          this.handleNetworkError("bl");
        });
    }
  };

  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Catalogue Package</b> - Created Successfully.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
    setTimeout(() => {
      this.props.history.push("/admin/productcatalogue");
    }, 3000);
  }

  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  onnumricfieldChange(e) {
    const { value } = e.target;
    const re = /^[0-9]*$/;

    if (e.target.name == "package_price") {
      if (re.test(value) == true) {
        this.setState({ package_price: value });

        if (value == "") {
          this.setState({
            package_priceError: (
              <small className="text-danger">Price is required.</small>
            ),
          });
        } else {
          this.setState({ package_priceError: null });
        }
      }
    }
    if (e.target.name == "discounted_price") {
      if (re.test(value) == true) {
        this.setState({ discounted_price: value });
      }
    }

    if (e.target.name == "package_duration") {
      if (re.test(value) == true) {
        this.setState({ package_duration: value });

        if (value == "") {
          this.setState({
            package_durationError: (
              <small className="text-danger">Duration is required.</small>
            ),
          });
        } else {
          this.setState({ package_durationError: null });
        }
      }
    }
  }

  setColor = (colors) => {
    this.setState({
      background_color: colors.hex,
    });
  };

  onChangenew = (e, i) => {
    const target = e.target;
    const value = target.value;
    this.setState({
      insurancekey1: value,
      insurancekey2: value,
    });
  };
  // this.setState(prevState => ({
  //   arrayvar: [...prevState.arrayvar, newelement]
  // }))

  handleUnlimitedMbe = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["unlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditMedicine = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditMedicine"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditMedicine"] = true;
    } else {
      list[i]["isFlashCreditMedicine"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditLab = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditLab"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditLab"] = true;
    } else {
      list[i]["isFlashCreditLab"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditRaya = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditRaya"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditRaya"] = true;
    } else {
      list[i]["isFlashCreditRaya"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedTalkGlobel = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["talkGlobelUnlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedTalkLater = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["talkLaterUnlimited"] = checked;
    if (checked == true) {
      list[i]["input_value"] = "unlimited";
      list[i]["checked"] = true;
    } else {
      list[i]["input_value"] = "";
    }

    this.setState({ feature_chk: list });
  };

  handleUnlimitedTalkLterSpeciality = (e, i, idx) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    var arr_val = list[i]["input_value"];
    arr_val[idx].isUnlimited = e.target.checked;
    list[i]["input_value"] = arr_val;

    if (checked) {
      arr_val[idx].no_of_calls = "unlimited";
    } else {
      arr_val[idx].no_of_calls = "";
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditTalkLater = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditTalkLater"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditTalkLater"] = true;
    } else {
      list[i]["isFlashCreditTalkLater"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditTalkNow = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditTalkNow"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditTalkNow"] = true;
    } else {
      list[i]["isFlashCreditTalkNow"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleFlashCreditTalkGlobal = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["isFlashCreditTalkGlobal"] = checked;
    if (checked == true) {
      list[i]["isFlashCreditTalkGlobal"] = true;
    } else {
      list[i]["isFlashCreditTalkGlobal"] = false;
    }

    this.setState({ feature_chk: list });
  };

  handleStandardDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["standard"] = checked;
    this.setState({
      feature_chk: list,
      standardFree: "",
      standardDiscount: "",
      standardBasePrice: "",
      standardDescription: "",
    });
  };

  handleExpressDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["express"] = checked;
    this.setState({
      feature_chk: list,
      expressFree: "",
      expressDiscount: "",
      expressBasePrice: "",
      expressDescription: "",
    });
  };
  handleIslandWideDelivery = (e, i) => {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["islandWide"] = checked;
    this.setState({
      feature_chk: list,
      islandWideFree: "",
      islandWideDiscount: "",
      islandWideBasePrice: "",
      islandWideDescription: "",
    });
  };

  onChangeDeliveryFields = (e) => {
    const re = /^[0-9]*$/;
    const { value } = e.target;
    if (e.target.name == "standradFree" && re.test(value)) {
      this.setState({ standardFree: value });
    } else if (e.target.name == "standradDiscount" && re.test(value)) {
      this.setState({ standardDiscount: value });
    } else if (e.target.name == "standradBasePrice" && re.test(value)) {
      this.setState({ standardBasePrice: value });
    } else if (e.target.name == "expressFree" && re.test(value)) {
      this.setState({ expressFree: value });
    } else if (e.target.name == "expressDiscount" && re.test(value)) {
      this.setState({ expressDiscount: value });
    } else if (e.target.name == "expressBasePrice" && re.test(value)) {
      this.setState({ expressBasePrice: value });
    } else if (e.target.name == "isLandWideFree" && re.test(value)) {
      this.setState({ islandWideFree: value });
    } else if (e.target.name == "isLandWideDiscount" && re.test(value)) {
      this.setState({ islandWideDiscount: value });
    } else if (e.target.name == "noOfFreeDelivery" && re.test(value)) {
      this.setState({ noOfFreeValue: value });
    } else if (e.target.name == "isLandWideBasePrice" && re.test(value)) {
      this.setState({ islandWideBasePrice: value });
    } else if (e.target.name == "standardDescription") {
      this.setState({ standardDescription: value });
    } else if (e.target.name == "expressDescription") {
      this.setState({ expressDescription: value });
    } else if (e.target.name == "islandWideDescription") {
      this.setState({ islandWideDescription: value });
    } else if (e.target.name == "welcomeNote") {
      this.setState({ deliveryWelcomeNote: value });
    }
  };

  //add multiple insurance
  handleInputChange = (e, index) => {
    const { name, value } = e.target;
    // const {value } = e.target.type === 'select' ? e.target.selected : e.target.value;
    const list = [...this.state.addresslist];
    list[index][name] = value;

    // if (list[index]["country"] != "0") {
    //   var token = JSON.parse(localStorage.getItem("user"));
    //   const obj = token.token;
    //   var country_id = list[index]["country"];
    //   getCity(obj, country_id).then((res) => {
    //     this.setState({ city_info: res.data });
    //   });
    // } else if (list[index]["country"] == "0") {
    //   this.setState({ city_info: [] });
    // }
    this.setState({ addresslist: list });
  };

  serial = 2;
  getSerial() {
    return this.serial++;
  }
  handleRemoveClick = (index) => {
    const list = [...this.state.addresslist];
    list.splice(index, 1);
    this.setState({ addresslist: list });
    const list1 = list;

    let count_x = 1;
    list1.map((medi, ind) => {
      list1[ind]["srno"] = count_x;
      count_x++;
    });
    this.serial = count_x;
  };

  handleAddClick = () => {
    this.setState({
      addresslist: [
        ...this.state.addresslist,
        {
          srno: this.getSerial(),
          address_line_1: "",
          address_line_2: "",
          // city: "",
          // state: "",
          // // country: 1,
          // postalcode: "",
          // // country_error: "",
          // city_error: "",
          // addresstype: "",
          // addresstypeError: "",
          // customaddress: "",
          // customaddressError: "",
        },
      ],
    });
  };

  onChangeShowMobileApp = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;

    this.setState({
      is_featured: value,
    });
  };

  handleAllClaim(e, i) {
    var checked = e.target.checked;
    var list = [...this.state.feature_chk_data];
    list[i]["checked"] = checked;

    if (checked == true) {
      list[i]["checked"] = true;
    } else {
      list[i]["checked"] = false;
      this.setState({
        claimValue: "",
        // claimPeriod: "",
        isClaimMedicine: false,
        isClaimLab: false,
        isClaimRaya: false,
        isClaimTalkGlobal: false,
        isClaimTalkLater: false,
        isClaimTalkNow: false,
        isClaimEchanneling: false,
      });
    }

    this.setState({ feature_chk: list });
  }

  onEditorStateChange = (type, editorState) => {
    if (type === "medicine") {
      this.setState({
        medicinePolicyDetails: { title: type, value: editorState },
      });
    } else if (type === "lab") {
      this.setState({ labPolicyDetails: { title: type, value: editorState } });
    } else if (type === "raya") {
      this.setState({ rayaPolicyDetails: { title: type, value: editorState } });
    } else if (type === "talkNow") {
      this.setState({
        talkNowPolicyDetails: { title: type, value: editorState },
      });
    } else if (type === "talkLater") {
      this.setState({
        talkLaterPolicyDetails: { title: type, value: editorState },
      });
    } else if (type === "talkGlobal") {
      this.setState({
        talkGlobalPolicyDetails: { title: type, value: editorState },
      });
    }
  };

  uploadPackagelLogo() {
    document.getElementById("selectpackage_logo").click();
  }
  handlePackageLogoFileChange(event) {
    this.setState({ package_logo: event.target.files[0] });
    this.setState({
      packageLogoError: null,
    });
  }

  render() {
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />
          <Row>
            <Col lg={10} md={12} sm={12}>
              <Card
                content={
                  <form>
                    <Row>
                      <Col md={12}>
                        <FormGroup>
                          <ControlLabel>Type</ControlLabel>
                          <select
                            className="react-select primary form-control"
                            name="user_type"
                            value={this.state.user_type}
                            onChange={(event) => {
                              this.setState({ user_type: event.target.value });
                            }}
                          >
                            {this.userType.map((ut, idx) => (
                              <option key={idx} value={ut.value}>
                                {ut.label}
                              </option>
                            ))}
                          </select>
                        </FormGroup>
                        <FormGroup>
                          <ControlLabel>Basic Type</ControlLabel>
                          <select
                            className="react-select primary form-control"
                            name="user_type"
                            value={this.state.package_type}
                            onChange={(event) => {
                              this.setState({
                                package_type: event.target.value,
                              });
                            }}
                          >
                            {this.basicType.map((ut, idx) => (
                              <option key={idx} value={ut.value}>
                                {ut.label}
                              </option>
                            ))}
                          </select>
                        </FormGroup>
                        {this.state.user_type == 2 ? (
                          <FormGroup>
                            <ControlLabel>Show in mobile app</ControlLabel>

                            <div className="order_source_data">
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="600"
                                option="1"
                                name="show_mobile_app"
                                onChange={this.onChangeShowMobileApp}
                                checked={this.state.is_featured === "1"}
                                label="Yes"
                              />
                              &nbsp;
                              <Radio
                                // style={{'display':'inline-block'}}
                                number="601"
                                option="0"
                                name="show_mobile_app"
                                onChange={this.onChangeShowMobileApp}
                                checked={this.state.is_featured === "0"}
                                label="No"
                              />
                            </div>
                          </FormGroup>
                        ) : null}
                        <FormGroup>
                          <>
                            <ControlLabel>Package Name</ControlLabel>
                            <FormControl
                              name="package_name"
                              value={this.state.package_name}
                              onChange={(event) => {
                                this.setState({
                                  package_name: event.target.value,
                                });
                                event.target.value === ""
                                  ? this.setState({
                                      package_nameError: (
                                        <small className="text-danger">
                                          Package name is required.
                                        </small>
                                      ),
                                    })
                                  : this.setState({ package_nameError: null });
                              }}
                              placeholder="Enter Package Name"
                              type="text"
                            />
                          </>
                          {this.state.package_nameError}
                        </FormGroup>

                        <>
                          <FormGroup>
                            <ControlLabel>Product Code</ControlLabel>
                            <FormControl
                              name="productCode"
                              value={this.state.productCode}
                              onChange={(event) => {
                                this.setState({
                                  productCode: event.target.value,
                                });
                              }}
                              placeholder="Enter Product Code"
                              type="text"
                            />
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Package Description</ControlLabel>
                            <FormControl
                              name="package_description"
                              value={this.state.package_description}
                              onChange={(event) => {
                                this.setState({
                                  package_description: event.target.value,
                                });
                              }}
                              placeholder="Enter Package Description"
                              type="text"
                            />
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Free Trail</ControlLabel>
                            <Row>
                              <Col sm={6}>
                                <select
                                  className="react-select primary form-control durationselect_package"
                                  name="free_trial_type"
                                  value={this.state.free_trial_type}
                                  onChange={(event) => {
                                    this.setState({
                                      free_trial_type: event.target.value,
                                    });
                                  }}
                                >
                                  {this.free_trial_type.map((ut, idx) => (
                                    <option key={idx} value={ut.value}>
                                      {ut.label}
                                    </option>
                                  ))}
                                </select>
                              </Col>
                              <Col sm={6}>
                                <FormControl
                                  name="free_trial"
                                  value={this.state.free_trial}
                                  onChange={(event) => {
                                    this.setState({
                                      free_trial: event.target.value,
                                    });
                                  }}
                                  placeholder="Enter Package Free Trail"
                                  type="text"
                                />
                              </Col>
                            </Row>
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Package Duration</ControlLabel>
                            <Row>
                              <Col sm={6}>
                                <FormControl
                                  name="package_duration"
                                  value={this.state.package_duration}
                                  onChange={(event) =>
                                    this.onnumricfieldChange(event)
                                  }
                                  placeholder="Enter Package Duration"
                                  type="text"
                                />
                                {this.state.package_durationError}
                              </Col>
                              <Col sm={6}>
                                <select
                                  className="react-select primary form-control durationselect_package"
                                  name="duration_type"
                                  value={this.state.duration_type}
                                  onChange={(event) => {
                                    this.setState({
                                      duration_type: event.target.value,
                                    });
                                  }}
                                >
                                  {this.duration_type.map((ut, idx) => (
                                    <option key={idx} value={ut.value}>
                                      {ut.label}
                                    </option>
                                  ))}
                                </select>
                              </Col>
                            </Row>
                          </FormGroup>
                          <Row>
                            <FormGroup>
                              <Col sm={6}>
                                <ControlLabel>Package Price</ControlLabel>
                                <FormControl
                                  name="package_price"
                                  value={this.state.package_price}
                                  onChange={(event) =>
                                    this.onnumricfieldChange(event)
                                  }
                                  placeholder="Enter Package Price"
                                  type="text"
                                />
                                {this.state.package_priceError}
                              </Col>
                              <Col sm={6}>
                                <ControlLabel>Discount</ControlLabel>

                                <FormControl
                                  name="discounted_price"
                                  value={this.state.discounted_price}
                                  onChange={(event) =>
                                    this.onnumricfieldChange(event)
                                  }
                                  placeholder="Enter Discount Price"
                                  type="text"
                                />
                              </Col>
                            </FormGroup>
                          </Row>
                          <Row>
                            <Col sm={6}>
                              <ControlLabel>Country</ControlLabel>
                              <select
                                name="country"
                                onChange={(event) => {
                                  this.setState({
                                    country_code: event.target.value,
                                  });
                                  this.setState({ countryError: null });
                                }}
                                className="form-control"
                              >
                                <React.Fragment>
                                  <option value="0">Select Country</option>
                                  {this.state.country_detail.map(
                                    (country_data) => (
                                      <option value={country_data.country_code}>
                                        {country_data.country_name}
                                      </option>
                                    )
                                  )}
                                </React.Fragment>
                              </select>
                              {this.state.countryError}
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col sm={6}>
                              <ControlLabel>Package Logo</ControlLabel>
                              <br></br>
                              <input
                                style={{ display: "none" }}
                                id="selectpackage_logo"
                                type="file"
                                className="form-control"
                                name="package_logo"
                                onChange={this.handlePackageLogoFileChange}
                              />
                              <Button
                                onClick={this.uploadPackagelLogo}
                                style={{ color: "#2B3A41" }}
                              >
                                {" "}
                                <i
                                  className={
                                    this.state.package_logo == ""
                                      ? "fa fa-plus"
                                      : "fa fa-pencil fa-fw"
                                  }
                                ></i>{" "}
                                {this.state.package_logo == ""
                                  ? "Choose Package Logo"
                                  : "Change Package Logo"}
                              </Button>
                            </Col>
                          </Row>
                        </>
                        {this.state.packageLogoError}

                        <>
                          <FormGroup className="backgroundcolorinput">
                            <ControlLabel>Background Color</ControlLabel>
                            <InputColor
                              initialValue="#5e72e4"
                              onChange={this.setColor}
                              placement="right"
                            />
                          </FormGroup>
                          <FormGroup>
                            <ControlLabel>Package Features</ControlLabel>
                            <div className="grp-feature">
                              {this.state.feature_chk_data.map((s, i) => (
                                <>
                                  <React.Fragment key={i}>
                                    <Row>
                                      {s.label == "Medicine" ? (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllCheckedMedicine(
                                                  e,
                                                  i
                                                )
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            <div
                                              className="mbe_ulmt_show_cont"
                                              style={{ display: "inline-flex" }}
                                            >
                                              {s.checked && (
                                                <>
                                                  <FormControl
                                                    style={{ width: "inherit" }}
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={s.input_value}
                                                    placeholder={s.placeholder}
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChange(e, i)
                                                    }
                                                  />
                                                  <Checkbox
                                                    number={s.id + 999}
                                                    key={i + 999}
                                                    checked={
                                                      s.isFlashCreditMedicine
                                                    }
                                                    onChange={(e) =>
                                                      this.handleFlashCreditMedicine(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Flashcredit"
                                                    value={
                                                      s.isFlashCreditMedicine
                                                    }
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Lab" ? (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllCheckedLab(e, i)
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            <div
                                              className="mbe_ulmt_show_cont"
                                              style={{ display: "inline-flex" }}
                                            >
                                              {s.checked && (
                                                <>
                                                  <FormControl
                                                    style={{ width: "inherit" }}
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={s.input_value}
                                                    placeholder={s.placeholder}
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChange(e, i)
                                                    }
                                                  />
                                                  <Checkbox
                                                    number={s.id + 998}
                                                    key={i + 998}
                                                    checked={s.isFlashCreditLab}
                                                    onChange={(e) =>
                                                      this.handleFlashCreditLab(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Flashcredit"
                                                    value={s.isFlashCreditLab}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Raya" ? (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllCheckedRaya(e, i)
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            <div
                                              className="mbe_ulmt_show_cont"
                                              style={{ display: "inline-flex" }}
                                            >
                                              {s.checked && (
                                                <>
                                                  <FormControl
                                                    style={{ width: "inherit" }}
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={s.input_value}
                                                    placeholder={s.placeholder}
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChange(e, i)
                                                    }
                                                  />
                                                  <Checkbox
                                                    number={s.id + 997}
                                                    key={i + 997}
                                                    checked={
                                                      s.isFlashCreditRaya
                                                    }
                                                    onChange={(e) =>
                                                      this.handleFlashCreditRaya(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Flashcredit"
                                                    value={s.isFlashCreditRaya}
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Talk global" ? (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllCheckedTalkLaterGlobal(
                                                  e,
                                                  i
                                                )
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            <div
                                              className="mbe_ulmt_show_cont"
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "baseline",
                                              }}
                                            >
                                              {s.checked && (
                                                <>
                                                  <FormControl
                                                    style={{ width: "inherit" }}
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={s.input_value}
                                                    placeholder={s.placeholder}
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChange(e, i)
                                                    }
                                                  />
                                                  <Checkbox
                                                    disabled={
                                                      s.isFlashCreditTalkGlobal
                                                    }
                                                    number={s.id + 220}
                                                    key={i + 220}
                                                    checked={
                                                      s.talkGlobelUnlimited
                                                    }
                                                    onChange={(e) =>
                                                      this.handleUnlimitedTalkGlobel(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Unlimited"
                                                    value={
                                                      s.talkGlobelUnlimited
                                                    }
                                                  />
                                                  <Checkbox
                                                    disabled={
                                                      s.talkGlobelUnlimited
                                                    }
                                                    number={s.id + 993}
                                                    key={i + 993}
                                                    checked={
                                                      s.isFlashCreditTalkGlobal
                                                    }
                                                    onChange={(e) =>
                                                      this.handleFlashCreditTalkGlobal(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Flashcredit"
                                                    value={
                                                      s.isFlashCreditTalkGlobal
                                                    }
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Talk later" ? (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllCheckedTalkLaterUnlimited(
                                                  e,
                                                  i
                                                )
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            <div
                                              className="mbe_ulmt_show_cont"
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "baseline",
                                              }}
                                            >
                                              {s.checked && (
                                                <>
                                                  <FormControl
                                                    style={{ width: "inherit" }}
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={s.input_value}
                                                    placeholder={s.placeholder}
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChange(e, i)
                                                    }
                                                  />
                                                  <Checkbox
                                                    disabled={
                                                      s.isFlashCreditTalkLater
                                                    }
                                                    number={s.id + 221}
                                                    key={i + 221}
                                                    checked={
                                                      s.talkGlobelUnlimited
                                                    }
                                                    onChange={(e) =>
                                                      this.handleUnlimitedTalkLater(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Unlimited"
                                                    value={
                                                      s.talkGlobelUnlimited
                                                    }
                                                  />
                                                  <Checkbox
                                                    disabled={
                                                      s.talkGlobelUnlimited
                                                    }
                                                    number={s.id + 996}
                                                    key={i + 996}
                                                    checked={
                                                      s.isFlashCreditTalkLater
                                                    }
                                                    onChange={(e) =>
                                                      this.handleFlashCreditTalkLater(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Flashcredit"
                                                    value={
                                                      s.isFlashCreditTalkLater
                                                    }
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Talk later speciality" ? (
                                        <Col sm={12}>
                                          <Checkbox
                                            number={s.id}
                                            key={i}
                                            checked={s.checked}
                                            onChange={(e) =>
                                              this.handleAllChecked_noc(e, i)
                                            }
                                            label={s.label}
                                            value={s.chk_value}
                                          />

                                          <div className="productcat-select">
                                            {s.checked && (
                                              <>
                                                <Button
                                                  disabled={!s.checked}
                                                  style={{
                                                    marginTop: "4px",
                                                    marginBottom: "20px",
                                                  }}
                                                  onClick={() =>
                                                    this.onNOCallAdd(i)
                                                  }
                                                >
                                                  Add
                                                </Button>
                                                <div className="pct_flaxcontainer">
                                                  {s.input_value.length > 0 &&
                                                    s.input_value.map(
                                                      (pccl, idx) => (
                                                        <div className="productcat_callcontainer">
                                                          <Select
                                                            className="pcat_callselect"
                                                            placeholder="Speciality"
                                                            closeMenuOnSelect={
                                                              true
                                                            }
                                                            value={
                                                              pccl.specility
                                                            }
                                                            onChange={(value) =>
                                                              this.onSpecialityChange(
                                                                value,
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                            options={
                                                              this.state
                                                                .doctorspecialityItems
                                                            }
                                                          />
                                                          <FormControl
                                                            disabled={
                                                              pccl.isUnlimited
                                                            }
                                                            value={
                                                              pccl.no_of_calls
                                                            }
                                                            placeholder="Number of Calls"
                                                            name={s.name}
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onCallChange(
                                                                e,
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                          />
                                                          &nbsp;
                                                          <Checkbox
                                                            number={
                                                              s.id + 1201 + idx
                                                            }
                                                            key={i + 1201 + idx}
                                                            checked={
                                                              pccl.isUnlimited
                                                            }
                                                            onChange={(e) =>
                                                              this.handleUnlimitedTalkLterSpeciality(
                                                                e,
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                            label="Unlimited"
                                                            value={
                                                              pccl.isUnlimited
                                                            }
                                                          />
                                                          &nbsp;&nbsp;
                                                          <Button
                                                            onClick={() =>
                                                              this.onNOCallRemove(
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                          >
                                                            x
                                                          </Button>
                                                        </div>
                                                      )
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Insurance" ? (
                                        <Col sm={12}>
                                          <Checkbox
                                            number={s.id}
                                            key={i}
                                            checked={s.checked}
                                            onChange={(e) =>
                                              this.handleAllChecked_noi(e, i)
                                            }
                                            label={s.label}
                                            value={s.chk_value}
                                          />
                                          {s.checked && (
                                            <>
                                              <div
                                                className="mbe_ulmt_show_cont"
                                                style={{
                                                  display: "inline-flex",
                                                }}
                                              >
                                                <div className="productcat-select">
                                                  <Select
                                                    isDisabled={!s.checked}
                                                    style={{
                                                      width:
                                                        "inherit !important",
                                                    }}
                                                    className="react-select primary insurance-dropdown"
                                                    classNamePrefix="react-select"
                                                    placeholder="Insurance"
                                                    name="insurance_id"
                                                    value={
                                                      this.state.insurance_id
                                                    }
                                                    onChange={(value) =>
                                                      this.setState({
                                                        insurance_id: value,
                                                      })
                                                    }
                                                    options={
                                                      this.state.insuranceUsers
                                                    }
                                                  />
                                                </div>
                                              </div>
                                              <div className="productcat-select">
                                                <Button
                                                  disabled={
                                                    s.checked == true
                                                      ? false
                                                      : true
                                                  }
                                                  style={{ marginTop: 4 }}
                                                  onClick={() =>
                                                    this.onNOCallAdd_test(i)
                                                  }
                                                >
                                                  Add
                                                </Button>
                                                <div className="pct_flaxcontainer">
                                                  {s.input_value.length > 0 &&
                                                    s.input_value.map(
                                                      (x, y) => (
                                                        <div className="productcat_callcontainer">
                                                          <FormControl
                                                            name="address_line_1"
                                                            value={
                                                              x.address_line_1
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputChangeAddresslist1(
                                                                e,
                                                                i,
                                                                y
                                                              )
                                                            }
                                                            placeholder="Key"
                                                            type="text"
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          />
                                                          {
                                                            this.state
                                                              .address_line_1Error
                                                          }
                                                          <FormControl
                                                            name="address_line_2"
                                                            value={
                                                              x.address_line_2
                                                            }
                                                            onChange={(e) =>
                                                              this.handleInputChangeAddresslist2(
                                                                e,
                                                                i,
                                                                y
                                                              )
                                                            }
                                                            placeholder="Value"
                                                            type="text"
                                                            style={{
                                                              width: "100%",
                                                            }}
                                                          />
                                                          <Button
                                                            onClick={() =>
                                                              this.onNOCallRemove(
                                                                i,
                                                                y
                                                              )
                                                            }
                                                          >
                                                            x
                                                          </Button>
                                                        </div>
                                                      )
                                                    )}
                                                </div>
                                              </div>
                                            </>
                                          )}
                                          <hr />
                                        </Col>
                                      ) : s.label == "Talk now" ? (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllChecked_noc(e, i)
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            <div
                                              className="mbe_ulmt_show_cont"
                                              style={{
                                                display: "inline-flex",
                                                alignItems: "baseline",
                                              }}
                                            >
                                              {s.checked && (
                                                <>
                                                  <FormControl
                                                    style={{ width: "inherit" }}
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={s.input_value}
                                                    placeholder={s.placeholder}
                                                    name={s.name}
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChange(e, i)
                                                    }
                                                  />
                                                  <Checkbox
                                                    disabled={
                                                      s.isFlashCreditTalkNow
                                                    }
                                                    number={s.id + 100}
                                                    key={i + 100}
                                                    checked={s.unlimited}
                                                    onChange={(e) =>
                                                      this.handleUnlimitedMbe(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Unlimited"
                                                    value={s.unlimited}
                                                  />
                                                  <Checkbox
                                                    disabled={s.unlimited}
                                                    number={s.id + 994}
                                                    key={i + 994}
                                                    checked={
                                                      s.isFlashCreditTalkNow
                                                    }
                                                    onChange={(e) =>
                                                      this.handleFlashCreditTalkNow(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                    label="Flashcredit"
                                                    value={
                                                      s.isFlashCreditTalkNow
                                                    }
                                                  />
                                                </>
                                              )}
                                            </div>
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label ==
                                        "Partner & Coupon Management" ? (
                                        <div style={{ marginLeft: "15px" }}>
                                          <Checkbox
                                            number={s.id}
                                            key={i}
                                            checked={s.checked}
                                            onChange={(e) =>
                                              this.handleAllChecked_pcm(e, i)
                                            }
                                            label={s.label}
                                            value={s.chk_value}
                                          />
                                          {s.checked && (
                                            <>
                                              <div className="productcat-select">
                                                <div className="productcat_callcontainer">
                                                  <select
                                                    disabled={!s.checked}
                                                    className="form-control"
                                                    name="tier-select"
                                                    onChange={
                                                      this.onChange_tier
                                                    }
                                                  >
                                                    <option value="">
                                                      SELECT TIERS{" "}
                                                    </option>
                                                    <option value="platinum">
                                                      Platinum
                                                    </option>
                                                    <option value="gold">
                                                      Gold
                                                    </option>
                                                    <option value="silver">
                                                      Silver
                                                    </option>
                                                    <option value="browns">
                                                      Browns
                                                    </option>
                                                  </select>
                                                  &nbsp;
                                                  <select
                                                    disabled={!s.checked}
                                                    className="form-control"
                                                    name="tier-select"
                                                    onChange={
                                                      this.onChange_tags
                                                    }
                                                  >
                                                    <option value="">
                                                      SELECT TIERS
                                                    </option>
                                                    {this.state.tagListOption[
                                                      this.state.tiers
                                                    ] &&
                                                      this.state.tagListOption[
                                                        this.state.tiers
                                                      ].map((option, index) => (
                                                        <option
                                                          key={index}
                                                          value={option.value}
                                                        >
                                                          {option.label}
                                                        </option>
                                                      ))}
                                                  </select>
                                                  &nbsp;
                                                  <div
                                                    style={{
                                                      marginRight: "25px",
                                                      width: "inherit",
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    <select
                                                      disabled={!s.checked}
                                                      className="form-control"
                                                      name="tier-select"
                                                      onChange={
                                                        this.onChange_coupons
                                                      }
                                                    >
                                                      <option value="">
                                                        SELECT Coupons{" "}
                                                      </option>
                                                      {this.state.couponList.map(
                                                        (option, index) => (
                                                          <option
                                                            key={index}
                                                            value={option.id}
                                                          >
                                                            {option.title}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "8px",
                                                  marginLeft: "120px",
                                                  padding: "10px",
                                                }}
                                              >
                                                {s.value.map((item, indexs) => (
                                                  <div
                                                    style={{
                                                      border: "1px solid black",
                                                      borderRadius: "10px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      position: "relative",
                                                      gap: "5px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "black",
                                                        padding:
                                                          "8px 0px 8px 16px",
                                                      }}
                                                      key={indexs}
                                                    >
                                                      {item.title}
                                                    </span>

                                                    <img
                                                      onClick={() =>
                                                        this.onRemove_coupon(
                                                          i,
                                                          indexs
                                                        )
                                                      }
                                                      style={{
                                                        padding: "5px",
                                                        background:
                                                          "transparent",
                                                        cursor: "pointer",
                                                        width: "35px",
                                                        alignSelf: "center",
                                                        color: "black",
                                                      }}
                                                      src="https://w7.pngwing.com/pngs/211/405/png-transparent-computer-icons-close-button-trademark-logo-sign-thumbnail.png"
                                                      alt="remove"
                                                    />
                                                  </div>
                                                ))}
                                              </div>
                                            </>
                                          )}
                                          <hr />
                                        </div>
                                      ) : s.label == "MBE Groups" ? (
                                        <div style={{ marginLeft: "15px" }}>
                                          <Checkbox
                                            number={s.id}
                                            key={i}
                                            checked={s.checked}
                                            onChange={(e) =>
                                              this.handleAllCheckedGroups(e, i)
                                            }
                                            label={s.label}
                                            value={s.chk_value}
                                          />
                                          {s.checked && (
                                            <>
                                              <div
                                                className="mbe_ulmt_show_cont"
                                                style={{
                                                  display: "inline-flex",
                                                }}
                                              >
                                                <div className="productcat-select">
                                                  <div className="productcat_callcontainer">
                                                    <select
                                                      disabled={!s.checked}
                                                      className="form-control"
                                                      name="tier-select"
                                                      onChange={
                                                        this.onChangeGroups
                                                      }
                                                    >
                                                      <option value="">
                                                        SELECT Group
                                                      </option>
                                                      {this.state.groupData.map(
                                                        (option, index) => (
                                                          <option
                                                            key={index}
                                                            value={option.id}
                                                          >
                                                            {option.group_name}
                                                          </option>
                                                        )
                                                      )}
                                                    </select>
                                                  </div>
                                                </div>
                                              </div>

                                              <div
                                                style={{
                                                  display: "flex",
                                                  gap: "8px",
                                                  marginLeft: "120px",
                                                  padding: "10px",
                                                }}
                                              >
                                                {s.value.map((item, indexs) => (
                                                  <div
                                                    style={{
                                                      border: "1px solid black",
                                                      borderRadius: "10px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      position: "relative",
                                                      gap: "5px",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "black",
                                                        padding:
                                                          "8px 0px 8px 16px",
                                                      }}
                                                      key={indexs}
                                                    >
                                                      {item.group_name}
                                                    </span>

                                                    <img
                                                      onClick={() =>
                                                        this.onRemove_groups(
                                                          i,
                                                          indexs
                                                        )
                                                      }
                                                      style={{
                                                        padding: "5px",
                                                        background:
                                                          "transparent",
                                                        cursor: "pointer",
                                                        width: "35px",
                                                        alignSelf: "center",
                                                        color: "black",
                                                      }}
                                                      src="https://w7.pngwing.com/pngs/211/405/png-transparent-computer-icons-close-button-trademark-logo-sign-thumbnail.png"
                                                      alt="remove"
                                                    />
                                                  </div>
                                                ))}
                                              </div>
                                            </>
                                          )}
                                          <hr />
                                        </div>
                                      ) : s.label == "Delivery" ? (
                                        <Col style={{ marginLeft: "15px" }}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllCheckedFreeDelivery(
                                                  e,
                                                  i
                                                )
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            {s.checked && (
                                              <>
                                                <div
                                                  style={{
                                                    display: "flex",
                                                  }}
                                                >
                                                  <FormControl
                                                    disabled={
                                                      s.checked == true
                                                        ? false
                                                        : true
                                                    }
                                                    value={
                                                      this.state.noOfFreeValue
                                                    }
                                                    placeholder="No Of Free Delivery"
                                                    name="noOfFreeDelivery"
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.onChangeDeliveryFields(
                                                        e,
                                                        i
                                                      )
                                                    }
                                                  />
                                                  {
                                                    this.state
                                                      .noOfFreeValueError
                                                  }
                                                  <div
                                                    style={
                                                      s.checked
                                                        ? {
                                                            display: "block",
                                                            width: "100%",
                                                            // marginLeft: "92px",
                                                          }
                                                        : { display: "none" }
                                                    }
                                                  >
                                                    <FormControl
                                                      disabled={
                                                        s.checked == true
                                                          ? false
                                                          : true
                                                      }
                                                      value={
                                                        this.state
                                                          .deliveryWelcomeNote
                                                      }
                                                      placeholder="Enter the welcome note"
                                                      name="welcomeNote"
                                                      type="text"
                                                      onChange={(e) =>
                                                        this.onChangeDeliveryFields(
                                                          e,
                                                          i
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                                <div
                                                  style={
                                                    s.checked
                                                      ? { display: "block" }
                                                      : { display: "none" }
                                                  }
                                                >
                                                  <Row>
                                                    <Col
                                                      sm={s.standard ? 12 : 4}
                                                    >
                                                      <div className="productcat-select">
                                                        <ControlLabel>
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 700}
                                                            key={i}
                                                            checked={s.standard}
                                                            onChange={(e) =>
                                                              this.handleStandardDelivery(
                                                                e,
                                                                i
                                                              )
                                                            }
                                                            label={
                                                              <b>Standard</b>
                                                            }
                                                          />
                                                        </ControlLabel>

                                                        {s.standard && (
                                                          <>
                                                            <div className="productcat_callcontainer">
                                                              <FormControl
                                                                disabled={
                                                                  s.standard
                                                                    ? false
                                                                    : true
                                                                }
                                                                placeholder="No Of Free"
                                                                name="standradFree"
                                                                type="text"
                                                                onChange={(e) =>
                                                                  this.onChangeDeliveryFields(
                                                                    e,
                                                                    i,
                                                                    "standard"
                                                                  )
                                                                }
                                                                value={
                                                                  this.state
                                                                    .standardFree
                                                                }
                                                              />
                                                              <FormControl
                                                                disabled={
                                                                  s.standard
                                                                    ? false
                                                                    : true
                                                                }
                                                                placeholder="Discount"
                                                                name="standradDiscount"
                                                                type="text"
                                                                onChange={(e) =>
                                                                  this.onChangeDeliveryFields(
                                                                    e,
                                                                    i,
                                                                    "standard"
                                                                  )
                                                                }
                                                                value={
                                                                  this.state
                                                                    .standardDiscount
                                                                }
                                                              />
                                                              <FormControl
                                                                disabled={
                                                                  s.standard
                                                                    ? false
                                                                    : true
                                                                }
                                                                placeholder="Base Price"
                                                                name="standradBasePrice"
                                                                type="text"
                                                                onChange={(e) =>
                                                                  this.onChangeDeliveryFields(
                                                                    e,
                                                                    i,
                                                                    "standard"
                                                                  )
                                                                }
                                                                value={
                                                                  this.state
                                                                    .standardBasePrice
                                                                }
                                                              />
                                                            </div>
                                                            <div>
                                                              <FormControl
                                                                disabled={
                                                                  s.standard
                                                                    ? false
                                                                    : true
                                                                }
                                                                placeholder="Enter the description"
                                                                name="standardDescription"
                                                                type="text"
                                                                onChange={(e) =>
                                                                  this.onChangeDeliveryFields(
                                                                    e,
                                                                    i,
                                                                    "standard"
                                                                  )
                                                                }
                                                                value={
                                                                  this.state
                                                                    .standardDescription
                                                                }
                                                                style={{
                                                                  width: "100%",
                                                                }}
                                                              />
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>
                                                    </Col>

                                                    <Col
                                                      sm={s.express ? 12 : 4}
                                                    >
                                                      <div className="productcat-select">
                                                        <ControlLabel>
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 701}
                                                            key={i}
                                                            checked={s.express}
                                                            onChange={(e) =>
                                                              this.handleExpressDelivery(
                                                                e,
                                                                i
                                                              )
                                                            }
                                                            label={
                                                              <b>Express</b>
                                                            }
                                                          />
                                                        </ControlLabel>

                                                        {s.express && (
                                                          <>
                                                            <div className="productcat_callcontainer">
                                                              <>
                                                                <FormControl
                                                                  value={
                                                                    this.state
                                                                      .expressFree
                                                                  }
                                                                  disabled={
                                                                    s.express
                                                                      ? false
                                                                      : true
                                                                  }
                                                                  placeholder="No Of Free"
                                                                  name="expressFree"
                                                                  type="text"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.onChangeDeliveryFields(
                                                                      e,
                                                                      i,
                                                                      "express"
                                                                    )
                                                                  }
                                                                />
                                                                <FormControl
                                                                  value={
                                                                    this.state
                                                                      .expressDiscount
                                                                  }
                                                                  disabled={
                                                                    s.express
                                                                      ? false
                                                                      : true
                                                                  }
                                                                  placeholder="Discount"
                                                                  name="expressDiscount"
                                                                  type="text"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.onChangeDeliveryFields(
                                                                      e,
                                                                      i,
                                                                      "express"
                                                                    )
                                                                  }
                                                                />
                                                                <FormControl
                                                                  value={
                                                                    this.state
                                                                      .expressBasePrice
                                                                  }
                                                                  disabled={
                                                                    s.express
                                                                      ? false
                                                                      : true
                                                                  }
                                                                  placeholder="Base Price"
                                                                  name="expressBasePrice"
                                                                  type="text"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.onChangeDeliveryFields(
                                                                      e,
                                                                      i,
                                                                      "express"
                                                                    )
                                                                  }
                                                                />
                                                              </>
                                                            </div>

                                                            <div>
                                                              <FormControl
                                                                disabled={
                                                                  s.express
                                                                    ? false
                                                                    : true
                                                                }
                                                                placeholder="Enter the description"
                                                                name="expressDescription"
                                                                type="text"
                                                                onChange={(e) =>
                                                                  this.onChangeDeliveryFields(
                                                                    e,
                                                                    i,
                                                                    "express"
                                                                  )
                                                                }
                                                                value={
                                                                  this.state
                                                                    .expressDescription
                                                                }
                                                                style={{
                                                                  width: "100%",
                                                                }}
                                                              />
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>
                                                    </Col>

                                                    <Col
                                                      sm={s.islandWide ? 12 : 4}
                                                    >
                                                      <div className="productcat-select">
                                                        <ControlLabel>
                                                          <Checkbox
                                                            disabled={
                                                              !s.checked
                                                            }
                                                            number={s.id + 702}
                                                            key={i}
                                                            checked={
                                                              s.islandWide
                                                            }
                                                            onChange={(e) =>
                                                              this.handleIslandWideDelivery(
                                                                e,
                                                                i
                                                              )
                                                            }
                                                            label={
                                                              <b>IslandWide</b>
                                                            }
                                                          />
                                                        </ControlLabel>

                                                        {s.islandWide && (
                                                          <>
                                                            <div className="productcat_callcontainer">
                                                              <>
                                                                <FormControl
                                                                  value={
                                                                    this.state
                                                                      .islandWideFree
                                                                  }
                                                                  disabled={
                                                                    s.islandWide
                                                                      ? false
                                                                      : true
                                                                  }
                                                                  placeholder="No Of Free"
                                                                  name="isLandWideFree"
                                                                  type="text"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.onChangeDeliveryFields(
                                                                      e,
                                                                      i,
                                                                      "islandWide"
                                                                    )
                                                                  }
                                                                />
                                                                <FormControl
                                                                  value={
                                                                    this.state
                                                                      .islandWideDiscount
                                                                  }
                                                                  disabled={
                                                                    s.islandWide
                                                                      ? false
                                                                      : true
                                                                  }
                                                                  placeholder="Discount"
                                                                  name="isLandWideDiscount"
                                                                  type="text"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.onChangeDeliveryFields(
                                                                      e,
                                                                      i,
                                                                      "islandWide"
                                                                    )
                                                                  }
                                                                />
                                                                <FormControl
                                                                  value={
                                                                    this.state
                                                                      .islandWideBasePrice
                                                                  }
                                                                  disabled={
                                                                    s.islandWide
                                                                      ? false
                                                                      : true
                                                                  }
                                                                  placeholder="Base Price"
                                                                  name="isLandWideBasePrice"
                                                                  type="text"
                                                                  onChange={(
                                                                    e
                                                                  ) =>
                                                                    this.onChangeDeliveryFields(
                                                                      e,
                                                                      i,
                                                                      "islandWide"
                                                                    )
                                                                  }
                                                                />
                                                              </>
                                                            </div>
                                                            <div>
                                                              <FormControl
                                                                disabled={
                                                                  s.islandWide
                                                                    ? false
                                                                    : true
                                                                }
                                                                placeholder="Enter the description"
                                                                name="islandWideDescription"
                                                                type="text"
                                                                onChange={(e) =>
                                                                  this.onChangeDeliveryFields(
                                                                    e,
                                                                    i,
                                                                    "islandWide"
                                                                  )
                                                                }
                                                                value={
                                                                  this.state
                                                                    .islandWideDescription
                                                                }
                                                                style={{
                                                                  width: "100%",
                                                                }}
                                                              />
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </div>{" "}
                                              </>
                                            )}
                                          </>
                                          <hr />
                                        </Col>
                                      ) : s.label == "Claim Module" ? (
                                        <Col sm={12} md={12} lg={12}>
                                          <Checkbox
                                            number={s.id}
                                            key={i}
                                            checked={s.checked}
                                            onChange={(e) =>
                                              this.handleAllClaim(e, i)
                                            }
                                            label={s.label}
                                          />
                                          {s.checked && (
                                            <>
                                              {/* <div className="productcat-select">
                              <div className="productcat_callcontainer">
                              <ControlLabel>
                                OPD Price
                              </ControlLabel>
                                <FormControl
                                  disabled={
                                    s.checked ? false : true
                                  }
                                  placeholder="Claim value"
                                  name="claimValue"
                                  type="text"
                                  onChange={(e) =>
                                    this.setState({
                                      claimValue:
                                        e.target.value,
                                    })
                                  }
                                  value={this.state.claimValue}
                                />
                              </div>
                            </div> */}
                                              <Row>
                                                <Col
                                                  sm={3}
                                                  md={3}
                                                  lg={3}
                                                  style={{
                                                    marginRight: "-56px",
                                                  }}
                                                >
                                                  <ControlLabel
                                                    style={{
                                                      paddingTop: "10px",
                                                      paddingLeft: "15px",
                                                    }}
                                                  >
                                                    Claim Allocation
                                                  </ControlLabel>
                                                  <FormControl
                                                    disabled={
                                                      this.state
                                                        .isUnlimitedClaim
                                                    }
                                                    placeholder="Claim Allocation"
                                                    name="claimValue"
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.setState({
                                                        claimValue:
                                                          e.target.value,
                                                      })
                                                    }
                                                    value={
                                                      this.state.claimValue
                                                    }
                                                  />
                                                  <br />
                                                  {this.state.claimValueError}
                                                  &nbsp;
                                                </Col>
                                                <Col sm={2} md={2} lg={2}>
                                                  <ControlLabel
                                                    style={{
                                                      paddingTop: "10px",
                                                      paddingLeft: "15px",
                                                    }}
                                                  >
                                                    Claim Type
                                                  </ControlLabel>
                                                  &nbsp;
                                                  <Select
                                                    isDisabled={
                                                      s.checked ? false : true
                                                    }
                                                    className="pcat_callselect"
                                                    placeholder="Claim Type"
                                                    onChange={(value) => {
                                                      this.setState({
                                                        claimType: value.value,
                                                      });
                                                    }}
                                                    options={
                                                      this.state
                                                        .claimTypeOptions
                                                    }
                                                  />
                                                </Col>
                                                <Col
                                                  sm={2}
                                                  md={2}
                                                  lg={2}
                                                  style={{
                                                    marginTop: "32px",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {/* <ControlLabel>
                              Is Unlimited Allocation ?
                            </ControlLabel>
                            <br /> */}
                                                  <div
                                                    style={{
                                                      marginTop: "7px",
                                                      marginLeft: "28px",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <Checkbox
                                                      number={s.id + 888}
                                                      key={i + 888}
                                                      checked={
                                                        this.state
                                                          .isUnlimitedClaim
                                                      }
                                                      onChange={(e) => {
                                                        this.setState({
                                                          isUnlimitedClaim:
                                                            e.target.checked,
                                                        });
                                                        if (e.target.checked) {
                                                          this.setState({
                                                            claimValue: "",
                                                          });
                                                        }
                                                      }}
                                                      label="Unlimited Allocation"
                                                      value={
                                                        this.state
                                                          .isUnlimitedClaim
                                                      }
                                                    />
                                                  </div>
                                                </Col>
                                                <Col
                                                  sm={2}
                                                  md={2}
                                                  lg={2}
                                                  style={{ marginTop: "32px" }}
                                                >
                                                  {/* <ControlLabel>
                              Allow System Claims ?
                            </ControlLabel>
                            <br /> */}
                                                  <div
                                                    style={{
                                                      marginTop: "7px",
                                                      marginLeft: "28px",
                                                      width: "100%",
                                                    }}
                                                  >
                                                    <Checkbox
                                                      number={s.id + 887}
                                                      key={i + 887}
                                                      checked={
                                                        this.state
                                                          .isSystemClaimAllowed
                                                      }
                                                      onChange={(e) =>
                                                        this.setState({
                                                          isSystemClaimAllowed:
                                                            e.target.checked,
                                                        })
                                                      }
                                                      label="Allow System Claim"
                                                      value={
                                                        this.state
                                                          .isUnlimitedClaim
                                                      }
                                                    />
                                                  </div>
                                                </Col>
                                                <Col
                                                  sm={3}
                                                  md={3}
                                                  lg={3}
                                                  style={{ marginTop: "32px" }}
                                                >
                                                  {/* <ControlLabel>
                              Is Bank Account Need ?
                            </ControlLabel>
                            <br /> */}
                                                  <div
                                                    style={{
                                                      marginTop: "7px",
                                                      marginLeft: "28px",
                                                      width: "100% !important",
                                                    }}
                                                  >
                                                    <Checkbox
                                                      style={{
                                                        width:
                                                          "100% !important",
                                                      }}
                                                      number={s.id + 886}
                                                      key={i + 886}
                                                      checked={
                                                        this.state
                                                          .isBankAccountNeeded
                                                      }
                                                      onChange={(e) =>
                                                        this.setState({
                                                          isBankAccountNeeded:
                                                            e.target.checked,
                                                        })
                                                      }
                                                      label="Bank Account Needed"
                                                      value={
                                                        this.state
                                                          .isUnlimitedClaim
                                                      }
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                              {/* <FormControl
                                style={{ width: "inherit" }}
                                disabled={
                                  s.checked ? false : true
                                }
                                placeholder="Claim Period"
                                name="claimPeriod"
                                type="text"
                                onChange={(e) => this.setState({ claimPeriod: e.target.value, })}
                                value={this.state.claimPeriod}
                              />
                              <Select
                                isDisabled={s.checked ? false : true}
                                className="pcat_callselect"
                                placeholder="Claim Period Type"
                                onChange={(value) => { this.setState({ claimPeriodType: value }) }}
                                options={[
                                  { value: "Day", label: "Day" },
                                  { value: "Month", label: "Month" },
                                  { value: "Year", label: "Year" },
                                ]}
                              /> */}
                                              &nbsp;
                                              <Row>
                                                <Col sm={3} md={3} lg={3}>
                                                  <ControlLabel
                                                    style={{
                                                      paddingTop: "10px",
                                                      paddingLeft: "15px",
                                                    }}
                                                  >
                                                    Billing Cycle
                                                  </ControlLabel>
                                                  &nbsp;
                                                  <Select
                                                    isDisabled={
                                                      s.checked ? false : true
                                                    }
                                                    className="pcat_callselect"
                                                    placeholder="Billing Cycle"
                                                    onChange={(value) => {
                                                      this.setState({
                                                        claimBillingCycle:
                                                          value.value,
                                                      });
                                                    }}
                                                    options={
                                                      this.state
                                                        .claimBillingCycleOptions
                                                    }
                                                  />
                                                </Col>
                                                <Col sm={3} md={3} lg={3}>
                                                  <ControlLabel
                                                    style={{
                                                      paddingTop: "10px",
                                                      paddingLeft: "15px",
                                                    }}
                                                  >
                                                    OPD Price
                                                  </ControlLabel>
                                                  <br />
                                                  <FormControl
                                                    disabled={
                                                      s.checked ? false : true
                                                    }
                                                    placeholder="Individual Price"
                                                    name="individualPrice"
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.setState({
                                                        opdIndividualPrice:
                                                          e.target.value,
                                                      })
                                                    }
                                                    value={
                                                      this.state
                                                        .opdIndividualPrice
                                                    }
                                                  />
                                                </Col>
                                                <Col sm={3} md={3} lg={3}>
                                                  <ControlLabel
                                                    style={{
                                                      paddingTop: "10px",
                                                      paddingLeft: "15px",
                                                    }}
                                                  >
                                                    Pool Limit
                                                  </ControlLabel>
                                                  <br />
                                                  <FormControl
                                                    disabled={
                                                      s.checked ? false : true
                                                    }
                                                    placeholder="Pool Limit"
                                                    name="poolValue"
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.setState({
                                                        poolValue:
                                                          e.target.value,
                                                      })
                                                    }
                                                    value={this.state.poolValue}
                                                  />
                                                </Col>
                                                <Col sm={3} md={3} lg={3}>
                                                  <ControlLabel
                                                    style={{
                                                      paddingTop: "10px",
                                                      paddingLeft: "15px",
                                                    }}
                                                  >
                                                    Family Allocation
                                                  </ControlLabel>
                                                  <FormControl
                                                    disabled={
                                                      s.checked &&
                                                      this.state.isClaimFamily
                                                        ? false
                                                        : true
                                                    }
                                                    placeholder="Family Allocation"
                                                    name="familyPrice"
                                                    type="text"
                                                    onChange={(e) =>
                                                      this.setState({
                                                        opdFamilyPrice:
                                                          e.target.value,
                                                      })
                                                    }
                                                    value={
                                                      this.state.opdFamilyPrice
                                                    }
                                                  />
                                                </Col>
                                              </Row>
                                              {/* <Select
                                  isDisabled={
                                    s.checked ? false : true
                                  }
                                  className="pcat_callselect"
                                  placeholder="Credit Type"
                                  onChange={(value) => {
                                    this.setState({
                                      creditType: value.value,
                                    });
                                  }}
                                  options={
                                    this.state.creditTypeList
                                  }
                                /> */}
                                              <div
                                                style={
                                                  s.checked
                                                    ? { display: "block" }
                                                    : { display: "none" }
                                                }
                                              >
                                                <Row>
                                                  <Col
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{
                                                      paddingLeft: "32px",
                                                    }}
                                                  >
                                                    <ControlLabel
                                                      style={{
                                                        paddingTop: "10px",
                                                        // paddingLeft: "70px",
                                                      }}
                                                    >
                                                      Manual Claim Features
                                                    </ControlLabel>
                                                    <div>
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 900}
                                                        key={i}
                                                        checked={
                                                          this.state.pharma ==
                                                          "Pharma"
                                                            ? true
                                                            : false
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            pharma: e.target
                                                              .checked
                                                              ? "Pharma"
                                                              : "",
                                                          })
                                                        }
                                                        label="Pharma"
                                                      />
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 90}
                                                        key={i}
                                                        checked={
                                                          this.state.lab ==
                                                          "Lab"
                                                            ? true
                                                            : false
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            lab: e.target
                                                              .checked
                                                              ? "Lab"
                                                              : "",
                                                          })
                                                        }
                                                        label="Lab"
                                                      />
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 91}
                                                        key={i}
                                                        checked={
                                                          this.state.consult ==
                                                          "Consult"
                                                            ? true
                                                            : false
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            consult: e.target
                                                              .checked
                                                              ? "Consult"
                                                              : "",
                                                          })
                                                        }
                                                        label="Consult"
                                                      />
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 92}
                                                        key={i}
                                                        checked={
                                                          this.state.hospital ==
                                                          "Hospital"
                                                            ? true
                                                            : false
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            hospital: e.target
                                                              .checked
                                                              ? "Hospital"
                                                              : "",
                                                          })
                                                        }
                                                        label="Hospital"
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                              <div
                                                style={
                                                  s.checked
                                                    ? { display: "block" }
                                                    : { display: "none" }
                                                }
                                              >
                                                <Row>
                                                  <Col
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                    style={{
                                                      paddingLeft: "32px",
                                                    }}
                                                  >
                                                    <ControlLabel
                                                      style={{
                                                        paddingTop: "10px",
                                                        // paddingLeft: "70px",
                                                      }}
                                                    >
                                                      Claim Category
                                                    </ControlLabel>
                                                    <div>
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 799}
                                                        key={i}
                                                        checked={
                                                          this.state
                                                            .isClaimMedicine
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimMedicine:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Medicine"
                                                      />

                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 802}
                                                        key={i}
                                                        checked={
                                                          this.state.isClaimLab
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimLab:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Lab"
                                                      />

                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 803}
                                                        key={i}
                                                        checked={
                                                          this.state.isClaimRaya
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimRaya:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Raya"
                                                      />

                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 804}
                                                        key={i}
                                                        checked={
                                                          this.state
                                                            .isClaimTalkNow
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimTalkNow:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Talk Now"
                                                      />

                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 805}
                                                        key={i}
                                                        checked={
                                                          this.state
                                                            .isClaimTalkLater
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimTalkLater:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Talk Later"
                                                      />

                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 806}
                                                        key={i}
                                                        checked={
                                                          this.state
                                                            .isClaimTalkGlobal
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimTalkGlobal:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Talk Global"
                                                      />
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 901}
                                                        key={i}
                                                        checked={
                                                          this.state
                                                            .isClaimEchanneling
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isClaimEchanneling:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="E-Channeling"
                                                      />
                                                      <Checkbox
                                                        disabled={!s.checked}
                                                        number={s.id + 903}
                                                        key={i}
                                                        checked={
                                                          this.state
                                                            .isHospitalization
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            isHospitalization:
                                                              e.target.checked,
                                                          })
                                                        }
                                                        label="Hospitalization"
                                                      />
                                                      <div className="Family_check">
                                                        <Checkbox
                                                          disabled={!s.checked}
                                                          number={s.id + 809}
                                                          key={i}
                                                          checked={
                                                            this.state
                                                              .isClaimFamily
                                                          }
                                                          onChange={(e) =>
                                                            this.setState({
                                                              isClaimFamily:
                                                                e.target
                                                                  .checked,
                                                            })
                                                          }
                                                          label="Family"
                                                        />
                                                      </div>
                                                      <div
                                                        style={{
                                                          borderBottom:
                                                            "1px solid #e3e3e3",
                                                          margin: "10px 0",
                                                        }}
                                                      />
                                                      <div>
                                                        {this.state
                                                          .isClaimFamily && (
                                                          <>
                                                            <div>
                                                              {/* <Select
                                  className="pcat_callselect"
                                  placeholder="Select family members"
                                  // value={pccl.doctorId}
                                  // onChange={(value) =>
                                  //   this.onDoctorSelectChange(
                                  //     value,
                                  //     i,
                                  //     idx
                                  //   )
                                  // }
                                  // value={this.findClaimFamilyType()}
                                  // onChange={(event) => {
                                  //   this.setState({
                                  //     claimFamilyType:
                                  //       event.target
                                  //         .value,
                                  //   });
                                  // }}
                                  options={
                                    this.familyType
                                  }
                                  isMulti
                                  closeMenuOnSelect={
                                    false
                                  }
                                /> */}
                                                              <ControlLabel>
                                                                Select the
                                                                beneficiary
                                                              </ControlLabel>
                                                            </div>
                                                            <div
                                                              style={{
                                                                borderBottom:
                                                                  "1px solid #e3e3e3",
                                                                margin:
                                                                  "10px 0",
                                                              }}
                                                            >
                                                              <Checkbox
                                                                disabled={
                                                                  !s.checked
                                                                }
                                                                number={
                                                                  s.id + 808
                                                                }
                                                                key={i}
                                                                checked={
                                                                  this.state
                                                                    .isClaimMother
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      isClaimMother:
                                                                        e.target
                                                                          .checked,
                                                                    }
                                                                  )
                                                                }
                                                                label="Mother"
                                                              />
                                                              <Checkbox
                                                                disabled={
                                                                  !s.checked
                                                                }
                                                                number={
                                                                  s.id + 807
                                                                }
                                                                key={i}
                                                                checked={
                                                                  this.state
                                                                    .isClaimFather
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      isClaimFather:
                                                                        e.target
                                                                          .checked,
                                                                    }
                                                                  )
                                                                }
                                                                label="Father"
                                                              />
                                                              <Checkbox
                                                                disabled={
                                                                  !s.checked
                                                                }
                                                                number={
                                                                  s.id + 810
                                                                }
                                                                key={i}
                                                                checked={
                                                                  this.state
                                                                    .isClaimSister
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      isClaimSister:
                                                                        e.target
                                                                          .checked,
                                                                    }
                                                                  )
                                                                }
                                                                label="Sister"
                                                              />
                                                              <Checkbox
                                                                disabled={
                                                                  !s.checked
                                                                }
                                                                number={
                                                                  s.id + 811
                                                                }
                                                                key={i}
                                                                checked={
                                                                  this.state
                                                                    .isClaimBrother
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      isClaimBrother:
                                                                        e.target
                                                                          .checked,
                                                                    }
                                                                  )
                                                                }
                                                                label="Brother"
                                                              />
                                                              <Checkbox
                                                                disabled={
                                                                  !s.checked
                                                                }
                                                                number={
                                                                  s.id + 812
                                                                }
                                                                key={i}
                                                                checked={
                                                                  this.state
                                                                    .isClaimSpouse
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      isClaimSpouse:
                                                                        e.target
                                                                          .checked,
                                                                    }
                                                                  )
                                                                }
                                                                label="Spouse"
                                                              />
                                                              <Checkbox
                                                                disabled={
                                                                  !s.checked
                                                                }
                                                                number={
                                                                  s.id + 813
                                                                }
                                                                key={i}
                                                                checked={
                                                                  this.state
                                                                    .isClaimChild
                                                                }
                                                                onChange={(e) =>
                                                                  this.setState(
                                                                    {
                                                                      isClaimChild:
                                                                        e.target
                                                                          .checked,
                                                                    }
                                                                  )
                                                                }
                                                                label="Child"
                                                              />
                                                            </div>
                                                          </>
                                                        )}
                                                      </div>

                                                      {this.state
                                                        .isClaimTalkGlobal ? (
                                                        <Col
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xs={12}
                                                        >
                                                          <FormGroup>
                                                            <ControlLabel>
                                                              Talk Global Policy
                                                              Details
                                                            </ControlLabel>
                                                            <Editor
                                                              editorState={
                                                                this.state
                                                                  .talkGlobalPolicyDetails
                                                                  .value
                                                              }
                                                              editorClassName="terms-editor"
                                                              onEditorStateChange={(
                                                                editorState
                                                              ) =>
                                                                this.onEditorStateChange(
                                                                  "talkGlobal",
                                                                  editorState
                                                                )
                                                              }
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {this.state
                                                        .isClaimTalkLater ? (
                                                        <Col
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xs={12}
                                                        >
                                                          <FormGroup>
                                                            <ControlLabel>
                                                              Talk Later Policy
                                                              Details
                                                            </ControlLabel>
                                                            <Editor
                                                              editorState={
                                                                this.state
                                                                  .talkLaterPolicyDetails
                                                                  .value
                                                              }
                                                              editorClassName="terms-editor"
                                                              onEditorStateChange={(
                                                                editorState
                                                              ) =>
                                                                this.onEditorStateChange(
                                                                  "talkLater",
                                                                  editorState
                                                                )
                                                              }
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {this.state
                                                        .isClaimTalkNow ? (
                                                        <Col
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xs={12}
                                                        >
                                                          <FormGroup>
                                                            <ControlLabel>
                                                              Talk Now Policy
                                                              Details
                                                            </ControlLabel>
                                                            <Editor
                                                              editorState={
                                                                this.state
                                                                  .talkNowPolicyDetails
                                                                  .value
                                                              }
                                                              editorClassName="terms-editor"
                                                              onEditorStateChange={(
                                                                editorState
                                                              ) =>
                                                                this.onEditorStateChange(
                                                                  "talkNow",
                                                                  editorState
                                                                )
                                                              }
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {this.state
                                                        .isClaimRaya ? (
                                                        <Col
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xs={12}
                                                        >
                                                          <FormGroup>
                                                            <ControlLabel>
                                                              Raya Policy
                                                              Details
                                                            </ControlLabel>
                                                            <Editor
                                                              editorState={
                                                                this.state
                                                                  .rayaPolicyDetails
                                                                  .value
                                                              }
                                                              editorClassName="terms-editor"
                                                              onEditorStateChange={(
                                                                editorState
                                                              ) =>
                                                                this.onEditorStateChange(
                                                                  "raya",
                                                                  editorState
                                                                )
                                                              }
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {this.state.isClaimLab ? (
                                                        <Col
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xs={12}
                                                        >
                                                          <FormGroup>
                                                            <ControlLabel>
                                                              Lab Policy Details
                                                            </ControlLabel>
                                                            <Editor
                                                              editorState={
                                                                this.state
                                                                  .labPolicyDetails
                                                                  .value
                                                              }
                                                              editorClassName="terms-editor"
                                                              onEditorStateChange={(
                                                                editorState
                                                              ) =>
                                                                this.onEditorStateChange(
                                                                  "lab",
                                                                  editorState
                                                                )
                                                              }
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                      ) : (
                                                        ""
                                                      )}
                                                      {this.state
                                                        .isClaimMedicine ? (
                                                        <Col
                                                          sm={12}
                                                          md={12}
                                                          lg={12}
                                                          xs={12}
                                                        >
                                                          <FormGroup>
                                                            <ControlLabel>
                                                              Medicine Policy
                                                              Details
                                                            </ControlLabel>
                                                            <Editor
                                                              editorState={
                                                                this.state
                                                                  .medicinePolicyDetails
                                                                  .value
                                                              }
                                                              editorClassName="terms-editor"
                                                              onEditorStateChange={(
                                                                editorState
                                                              ) =>
                                                                this.onEditorStateChange(
                                                                  "medicine",
                                                                  editorState
                                                                )
                                                              }
                                                            />
                                                          </FormGroup>
                                                        </Col>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </>
                                          )}
                                          <hr />
                                        </Col>
                                      ) : s.label ==
                                        "Talk Later Doctor wise" ? (
                                        <Col sm={12}>
                                          <Checkbox
                                            number={s.id}
                                            key={i}
                                            checked={s.checked}
                                            onChange={(e) =>
                                              this.handleAllChecked_noc(e, i)
                                            }
                                            label={s.label}
                                            value={s.chk_value}
                                          />

                                          <div className="productcat-select-doctor">
                                            {s.checked && (
                                              <>
                                                <Button
                                                  disabled={!s.checked}
                                                  style={{
                                                    marginTop: "4px",
                                                    marginBottom: "40px",
                                                  }}
                                                  onClick={() =>
                                                    this.onAddNewSpecialityDoctor(
                                                      i
                                                    )
                                                  }
                                                >
                                                  Add
                                                </Button>
                                                <div className="pct_flaxcontainer">
                                                  {s.input_value.length > 0 &&
                                                    s.input_value.map(
                                                      (pccl, idx) => (
                                                        <div className="productcat_callcontainer">
                                                          <Select
                                                            className="pcat_callselect"
                                                            placeholder="doctor name"
                                                            closeMenuOnSelect={
                                                              true
                                                            }
                                                            value={pccl.doctors}
                                                            onChange={(value) =>
                                                              this.onDoctorSelectChange(
                                                                value,
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                            options={
                                                              this.state
                                                                .getAllDoctors
                                                            }
                                                          />
                                                          <FormControl
                                                            value={
                                                              pccl.no_of_calls
                                                            }
                                                            placeholder="Number of Calls"
                                                            name={s.name}
                                                            type="text"
                                                            onChange={(e) =>
                                                              this.onCallChange(
                                                                e,
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                          />
                                                          <Button
                                                            onClick={() =>
                                                              this.onTalkLaterDoctorWiseRemove(
                                                                i,
                                                                idx
                                                              )
                                                            }
                                                          >
                                                            x
                                                          </Button>
                                                        </div>
                                                      )
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                          <hr />
                                        </Col>
                                      ) : (
                                        <Col sm={12}>
                                          <>
                                            <Checkbox
                                              number={s.id}
                                              key={i}
                                              checked={s.checked}
                                              onChange={(e) =>
                                                this.handleAllChecked(e, i)
                                              }
                                              label={s.label}
                                              value={s.chk_value}
                                            />
                                            {s.checked && (
                                              <FormControl
                                                disabled={
                                                  s.checked == true
                                                    ? false
                                                    : true
                                                }
                                                value={s.input_value}
                                                placeholder={s.placeholder}
                                                name={s.name}
                                                type="text"
                                                onChange={(e) =>
                                                  this.onChange(e, i)
                                                }
                                                style={{
                                                  width: "inherit",
                                                  marginRight: "10px",
                                                }}
                                              />
                                            )}
                                          </>
                                          <hr />
                                        </Col>
                                      )}
                                    </Row>

                                    <div></div>
                                  </React.Fragment>
                                </>
                              ))}
                            </div>
                          </FormGroup>
                        </>
                        {this.state.feature_chkError}
                      </Col>
                    </Row>

                    <Button
                      disabled={!this.state.processing}
                      onClick={this.onSubmit.bind(this)}
                      className="btn-color" //bsStyle="info"
                      fill
                    >
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addProductCatalogue;
